<mx-preloader preloaderName="report"></mx-preloader>

<mat-card>
    <div class="form">
        <div class="form-group row">
            <mat-form-field id="transactionType" class="mxs-input">
                <mat-label><prl-label value="label.finance.transactions.type"/></mat-label>
                <mat-select hideSingleSelectionIndicator="true"
                            [formControl]="selectedTransactionTypeControl"
                            required>
                    @for (type of transactionTypes; track type) {
                        <mat-option  [value]="type">{{ type.value }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field id="dateRange" class="mxs-input">
                <mat-label><prl-label value="label.stats.data.range"/></mat-label>
                <mat-select hideSingleSelectionIndicator="true"
                            [formControl]="selectedDateRangeControl"
                            required>
                    @for (dateRange of dateRanges; track dateRange) {
                        <mat-option  [value]="dateRange">{{ (dateRange.value | mxTranslate)() }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            @if (balancePerMerchant) {
                <mat-form-field id="merchant" class="mxs-input">
                    <mat-label>
                        <prl-label value="label.finance.transactions.merchant"/>
                    </mat-label>
                    <mat-select hideSingleSelectionIndicator="true"
                                [formControl]="selectedMerchantControl"
                                required>
                        @for (merchant of merchants; track merchant) {
                            <mat-option [value]="merchant">{{ merchant.value }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        </div>
    </div>

    <mat-card-actions>
        <mx-button [buttonModel]="runReportButton"></mx-button>
        <mx-button [buttonModel]="exportReportButton"></mx-button>
        <mx-info-tooltip [config]="exportReportConfig"></mx-info-tooltip>
    </mat-card-actions>
</mat-card>

<mat-card class="table">
    <mx-grid [ngClass]="{'empty' : !isDataReady}" (customize)='onCustomize($event)'></mx-grid>
</mat-card>


